// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';


//page component

import VidGalleryContent from './PageComponent/VidGalleryContent';

function VideosGallery() {

  useMeta({
    title: 'Videos Gallery | Callistus Blinds',
    description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
    canonical: 'https://callistusblinds.com/videos-gallery/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Videos Gallery | Callistus Blinds',
      description:
        'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
      url: 'https://callistusblinds.com/videos-gallery/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <VidGalleryContent />
      <Footer />
    </div>
  );
}

export default VideosGallery;
